import { html } from 'lit';
import { property, query } from 'lit/decorators.js';
import { styles } from '../view/styles';
import { FormFieldInput } from '../../gzForm/formField/component/FormFieldInput';
import type { SelectedTime } from '../types';
import { TimePickerEvents } from '../types';
import { GzInputNumberWebComponent, InputWidthValues } from '../../gzInput';
import { isEqual } from 'lodash';

export class GzTimePickerWebComponent extends FormFieldInput<SelectedTime> {
  // see https://lit-element.polymer-project.org/guide/properties
  @property({ type: Object, attribute: true, reflect: true })
  time: SelectedTime;

  @property({ type: String, attribute: true, reflect: true })
  hourLabel = '';

  @property({ type: String, attribute: true, reflect: true })
  minuteLabel = '';

  @property({ attribute: true, reflect: true })
  inputWidth = InputWidthValues.SMALL;

  @query('#hour')
  private hour: GzInputNumberWebComponent;

  @query('#minute')
  private minute: GzInputNumberWebComponent;

  // see https://lit-element.polymer-project.org/guide/styles
  static get styles() {
    return styles;
  }

  render() {
    return html`
      <div class="wrapper-time-picker">
        <gz-input-number
          id="hour"
          ?disabled="${this.disabled}"
          @change="${this.setTime}"
          circular
          minLength="2"
          min="0"
          max="23"
          placeholder="00"
          unitSuffix="${this.hourLabel}"
          inputWidth="${this.inputWidth}"
          .value="${this.time ? this.time.hours : undefined}"
        ></gz-input-number>
        <div class="dots">:</div>
        <gz-input-number
          id="minute"
          ?disabled="${this.disabled}"
          @change="${this.setTime}"
          circular
          minLength="2"
          min="0"
          max="59"
          placeholder="00"
          unitSuffix="${this.minuteLabel}"
          inputWidth="${this.inputWidth}"
          .value="${this.time ? this.time.minutes : undefined}"
        ></gz-input-number>
      </div>
    `;
  }

  public setFormValue(value: SelectedTime) {
    this.time = value;
  }

  public getFormValue(): SelectedTime {
    return this.time;
  }

  public setEnabled(isEnabled: boolean): void {
    this.hour.setEnabled(isEnabled);
    this.minute.setEnabled(isEnabled);
  }

  private setTime() {
    const newTime: SelectedTime = {
      hours: this.hour.value ?? 0,
      minutes: this.minute.value ?? 0,
    };
    this.setFormValue(newTime);
    this.dispatchEvent(
      new CustomEvent(TimePickerEvents.CHANGE, {
        detail: {
          time: newTime,
        },
      })
    );
  }

  /**
   * Overrides FormFieldInput method for comparing two objects
   * (this component uses object as form field value)
   */
  public areFormValuesEqual(value1: SelectedTime, value2: SelectedTime) {
    return isEqual(value1, value2);
  }
}
